import { routeAccessGuard, routeAccessMatch } from '@core/guards/route-access.guard';

import { Routes } from '@angular/router';
import { NotAuthorizedComponent } from '@ui/components/not-authorized/not-authorized.component';
import { NotFoundComponent } from '@ui/components/not-found/not-found.component';

export const routes: Routes = [
  {
    path: 'home',
    loadComponent: () => import('./features/home/home.component').then(m => m.HomeComponent),
    data: { breadcrumb: 'Home', guestOnly: false },
  },
  {
    path: 'private',
    canActivate: [routeAccessGuard],
    canMatch: [routeAccessMatch],
    data: {
      breadcrumb: 'Area Riservata',
      breadcrumbLink: '/private/dashboard',
      requiresAuth: true,
      redirectGuest: '/home',
    },
    loadChildren: () => import('./features/private/private.routes').then(m => m.PRIVATE_ROUTES),
  },
  {
    path: 'punti-di-contatto',
    loadComponent: () =>
      import('./features/contact-point/contract-point.page.component').then(m => m.ContactPointPageComponent),
    data: { breadcrumb: 'Punti di contatto' },
  },
  {
    path: 'about-us',
    loadComponent: () => import('./features/about-us/about-us-page.component').then(m => m.AboutUsPageComponent),
    data: { breadcrumb: 'Chi siamo' },
  },
  {
    path: 'news',
    loadComponent: () => import('./features/news/news-page.component').then(m => m.NewsPageComponent),
    data: { breadcrumb: 'News' },
  },
  {
    path: 'bandi/aperti',
    loadComponent: () => import('./features/bandi-gestiti/bandi-gestiti.component').then(m => m.BandiGestitiComponent),
    data: { breadcrumb: 'Bandi aperti / Prossima apertura' },
  },
  {
    path: 'bandi/chiusi',
    loadComponent: () => import('./features/bandi-gestiti/bandi-gestiti.component').then(m => m.BandiGestitiComponent),
    data: { breadcrumb: 'Bandi chiusi' },
  },
  {
    path: 'bandi/:categoria',
    loadComponent: () => import('./features/bandi-gestiti/bandi-gestiti.component').then(m => m.BandiGestitiComponent),
    data: { breadcrumb: 'Bandi gestiti' },
  },
  {
    path: 'privacy-trasparenza',
    loadComponent: () => import('./features/privacy/privacy-page.component').then(m => m.PrivacyPageComponent),
    data: { breadcrumb: 'Privacy & Trasparenza' },
  },
  {
    path: 'contatti',
    loadComponent: () => import('./features/contatti/contatti-page.component').then(m => m.ContattiPageComponent),
    data: { breadcrumb: 'Contatti' },
  },
  {
    path: 'Home/RipristinaCredenziali',
    loadComponent: () => import('@ui/components/reset-credentials.component').then(m => m.ResetCredentialsComponent),
    data: { breadcrumb: 'Ripristino credenziali' },
  },
  {
    path: 'registrazione',
    loadComponent: () => import('./features/registrazione/registrazione.component').then(m => m.RegistrazioneComponent),
    data: { breadcrumb: 'Registrazione' },
  },
  {
    path: 'Home/ConfermaEmail',
    loadComponent: () =>
      import('./features/conferma-email/conferma-email.component').then(m => m.ConfermaEmailComponent),
    data: { breadcrumb: 'Conferma Email' },
  },
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full',
  },
  {
    path: 'not-authorized',
    component: NotAuthorizedComponent,
    data: { breadcrumb: 'Accesso non autorizzato' },
  },
  {
    path: '**',
    component: NotFoundComponent,
    data: { breadcrumb: 'Pagina non trovata' },
  },
];
